import { defineStore } from 'pinia'

import { StoreState } from '@shared/models/interfaces/store'
import { Nullable } from '@shared/models/types/primary'
import { resourcePath } from '@shared/plugins/api'
import { ApiTransport } from '@shared/plugins/api-transport'
import {
  getInitialState,
  updateState,
} from '@shared/utils/store/http-request-state'

import { FormSubmissionWorkflowState } from '@protos/chat/form_submission_workflow_state_pb'

import { PlainMessage } from '@bufbuild/protobuf'
import {
  FormSubmissionCompleteFormDTO as CompleteFormDTO,
  FormSubmissionIndexDTO,
  InitFormSubmissionOpenedAtDTO,
} from '@pc/models/proto/dto/form-submission'
import {
  FormSubmissionIndexRO,
  FormSubmissionItemRO,
} from '@pc/models/proto/ro/form-submission'

interface State {
  formSubmissions: StoreState<FormSubmissionIndexRO>
  quickFormId: Nullable<number>
}

const state = (): State => ({
  formSubmissions: getInitialState(),
  quickFormId: null,
})
export const apiTransport = new ApiTransport(resourcePath, 'pc')

export const useFormSubmissionsStore = defineStore('form-submissions', {
  state,

  actions: {
    async fetchFormSubmissions({
      page,
      quickFormId,
    }: Pick<PlainMessage<FormSubmissionIndexDTO>, 'page' | 'quickFormId'>) {
      try {
        this.formSubmissions = updateState(this.formSubmissions)

        const dto = new FormSubmissionIndexDTO({
          page,
          perPage: 20,
          source: 'self_requested',
          workflowState: FormSubmissionWorkflowState.SUBMITTED,
          quickFormId,
        })

        const response = await apiTransport.get(
          '/form_submissions',
          dto,
          FormSubmissionIndexRO
        )

        this.formSubmissions = updateState(this.formSubmissions, response)
      } catch (error) {
        this.formSubmissions = updateState(this.formSubmissions, error as Error)
        throw error
      }
    },

    async submitQuickFormOpenedAt(
      submission: PlainMessage<InitFormSubmissionOpenedAtDTO>
    ) {
      const response = await apiTransport.post(
        '/form_submissions/init_form_submission_opened_at',
        new InitFormSubmissionOpenedAtDTO(submission),
        InitFormSubmissionOpenedAtDTO,
        FormSubmissionItemRO
      )

      return response
    },

    async submitFormCompleted(submission: PlainMessage<CompleteFormDTO>) {
      const response = await apiTransport.post(
        '/form_submissions/complete_form',
        new CompleteFormDTO(submission),
        CompleteFormDTO,
        FormSubmissionItemRO
      )

      this.quickFormId = response.data?.quickFormId ?? 0

      return response.data!
    },
  },
})
